import SidebarPanelContent from "../common/SidebarPanelContent";

const SidebarPanel = ({ collapsed, expanded }) => {
  return <SidebarPanelContent collapsed={collapsed} expanded={expanded} />;
};

export default SidebarPanel;
